import React, { useMemo, useState } from 'react';
import Text from '../../../../Components/Base/Text/Text';
import MagicForm from '../../../../Components/Form/MagicForm';
import FullPageLoading from '../../../../Components/Utils/FullPageLoading/FullPageLoading';
import { useEffectAsync } from '../../../../helpers';
import { useHealthPlanContext } from '../../../../Services/HealthPlanContext';
import useHealthPlanOtherConsultationsForm from '../../Hooks/useHealthPlanOtherConsultationsForm';
import HealthPlanPrintPdfModal from '../HealthPlanPrintPdf/HealthPlanPrintPdfModal';

interface HealthPlanOtherConsultationsProps {
	onSuccess?: () => void;
	disableSubmit?: boolean;
}

export default function HealthPlanOtherConsultations(
	props: HealthPlanOtherConsultationsProps,
) {
	const { onSuccess, disableSubmit } = props;
	const { healthPlanUser, activeHealthPlanUserItem } = useHealthPlanContext();
	const { formScheme, submitValues } = useHealthPlanOtherConsultationsForm();
	const [isInitialized, setInitialized] = useState(false);
	const [defaultValues, setDefaultValues] = useState([]);
	const [printModalOpen, setPrintModalOpen] = useState(false);

	useEffectAsync(async () => {
		setDefaultValues(activeHealthPlanUserItem?.extra?.data ?? []);
		setInitialized(true);
	}, [activeHealthPlanUserItem]);

	const handleSave = async (values: any) => {
		const result = await submitValues?.(values, onSuccess);
		if (result) setPrintModalOpen(true);
	};

	const handleAfterPrint = async () => {
		setPrintModalOpen(false);
		onSuccess?.();
	};

	if (!isInitialized) {
		return <FullPageLoading />;
	}

	return (
		<>
			<Text
				className='danger-text text-center mb-4'
				tx={'component.otherConsultationComponent.warning'}
			/>
			<MagicForm
				formScheme={formScheme}
				defaultValues={defaultValues}
				onSubmit={handleSave}
				disableSubmit={disableSubmit}
			/>
			<HealthPlanPrintPdfModal
				opened={printModalOpen}
				onClose={handleAfterPrint}
				healthPlanUser={healthPlanUser}
				healthPlanUserItem={activeHealthPlanUserItem}
			/>
		</>
	);
}
